// removed by extract-text-webpack-plugin
module.exports = {"container":"_1mTt2GhPj7zd0Uiz070EBT","title":"_5OR65_XClTkrhFBQDPTDI","icon":"_1RZE8Sh1SdVMIz6E_bPj-P","Email":"_2U9x5r67TljrfUUoiEf1LJ","Signer":"jMN7BhzpMbUNqCufuJNBj"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Viewers/styles.css
// module id = 2849
// module chunks = 0